const Skeleton = () => {
  return (
    <div className="animate-pulse" role="status">
      <div className="bg-white-100 border-b-darkKnight-200 z-[999999] mt-[52px] flex h-[146px] w-full flex-col items-center justify-center gap-3 rounded-2xl border border-solid border-[color:var(--Border-Subtle,#E8E8EB)] p-4 max-md:mt-8 max-md:!rounded-none max-md:!border-none max-md:bg-neutral-100 max-md:!py-8">
        <div className="flex h-4 min-w-[300px] items-center justify-between rounded-md bg-gray-200 px-4 md:container md:px-0 lg:gap-10"></div>
        <div className="flex h-full gap-1.5">
          <div className="h-full min-w-[72px] rounded-md bg-gray-200"></div>
          <div className="flex h-full w-full flex-col justify-between gap-1.5">
            <div className="h-10 w-[100px] rounded-md bg-gray-200"></div>
            <div className="h-10 w-[100px] rounded-md bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
